import { QueryClient } from '@tanstack/react-query';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { persistQueryClient } from '@tanstack/react-query-persist-client';

// Keep the client's cache + mutation queue on disk so writes survive a
// refresh mid-flight. TanStack Query replays paused mutations on rehydrate.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 7 * 24 * 60 * 60 * 1000, // 7 days
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Keep a paused mutation if offline; TanStack will retry on reconnect.
      retry: 3,
      retryDelay: (i) => Math.min(1000 * 2 ** i, 30_000),
    },
  },
});

const persister = createSyncStoragePersister({
  storage: typeof window !== 'undefined' ? window.localStorage : null,
  key: 'proxera.rq.cache.v1',
});

export function setupPersister() {
  if (typeof window === 'undefined') return;
  persistQueryClient({
    queryClient,
    persister,
    maxAge: 7 * 24 * 60 * 60 * 1000,
    // Bump this if the cache shape changes and you want to invalidate stale caches.
    buster: 'v1',
  });
}
